"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var buttons_1 = require("../buttons");

var Icon_1 = require("../Icon/Icon");

var Layout_1 = require("../Layout");

var LogoMascot_1 = __importDefault(require("../LogoMascot/LogoMascot"));

var styled_1 = require("./styled");

var ContentPageModal =
/** @class */
function (_super) {
  __extends(ContentPageModal, _super);

  function ContentPageModal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ContentPageModal.prototype.render = function () {
    var _a = this.props,
        visible = _a.visible,
        children = _a.children,
        closeAction = _a.closeAction,
        scrollable = _a.scrollable;
    var _b = this.context,
        activeBreakpoint = _b.activeBreakpoint,
        height = _b.height;
    return react_1.default.createElement(styled_1.ModalContainer, {
      visible: visible,
      height: height,
      activeBreakpoint: activeBreakpoint,
      scrollable: scrollable
    }, react_1.default.createElement(Layout_1.Header, null, react_1.default.createElement(LogoMascot_1.default, {
      color: "purple",
      version: {
        sm: 'image',
        lg: 'image'
      }
    }), react_1.default.createElement(buttons_1.Button, {
      onPress: closeAction,
      text: "Close",
      type: buttons_1.ButtonTypeEnum.link,
      uppercase: true,
      icon: {
        name: 'close',
        position: buttons_1.ButtonIconPositionEnum.right,
        size: Icon_1.IconSizeEnum.small
      }
    })), react_1.default.createElement(styled_1.PageModalContentContainer, {
      activeBreakpoint: activeBreakpoint
    }, typeof children === 'function' ? children() : children));
  };

  ContentPageModal.contextType = responsive_1.ResponsiveContext;
  return ContentPageModal;
}(react_1.default.Component);

exports.ContentPageModal = ContentPageModal;